module.exports = __webpack_public_path__ + "static/media/h15_tcm.7bc0bf5e.webp";